module.exports = __webpack_public_path__ + "642739b3d2ce83f4289558a5a0b693aa.bg_main.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_main.jpg
// module id = kkcO
// module chunks = 0